import * as Yup from 'yup';

export const scheduleEmailModalValidationSchema = Yup.object().shape({
  timeZone: Yup.object().nullable().required('Timezone is required'),
  scheduleDate: Yup.string().nullable().required('Schedule date is required'),
  scheduleTime: Yup.string().nullable().required('Schedule time is required'),
});
